import React from 'react';
import { Avatar, AvatarProps, Skeleton } from '@mui/material';
import { Student } from '@/types';
import { photoService } from '@/services/photoService';

interface StudentAvatarProps extends Omit<AvatarProps, 'src'> {
  student: Student;
  showPlaceholder?: boolean;
}

export const StudentAvatar: React.FC<StudentAvatarProps> = ({ 
  student, 
  showPlaceholder = false,
  ...props 
}) => {
  const [isLoading, setIsLoading] = React.useState(true);
  const [error, setError] = React.useState(false);

  const photoUrl = photoService.getStudentPhoto(student);

  React.useEffect(() => {
    if (showPlaceholder) {
      setIsLoading(false);
      return;
    }

    const img = new Image();
    img.src = photoUrl;
    
    img.onload = () => {
      setIsLoading(false);
      setError(false);
    };
    
    img.onerror = () => {
      setIsLoading(false);
      setError(true);
    };
  }, [photoUrl, showPlaceholder]);

  if (showPlaceholder || isLoading) {
    return (
      <Skeleton
        variant="circular"
        width={40}
        height={40}
      />
    );
  }

  return (
    <Avatar
      {...props}
      src={error ? undefined : photoUrl}
      alt={`${student.firstName} ${student.lastName}`}
    >
      {student.firstName[0]}{student.lastName[0]}
    </Avatar>
  );
};